import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { NotificationProvider } from './context/NotificationContext';

// Page Components
import Home from './pages/Home';
import SignIn from './pages/SignIn';
import ForgotPassword from './pages/ForgotPassword';
import CourseDetails from './pages/CourseDetails';
import LabDetails from './pages/LabDetails';
import ContentViewer from './pages/ContentViewer';
import CompletedLesson from './pages/ContentViewer/Completed';
import MyLearning from './pages/MyLearning';
import Ongoing from './pages/MyLearning/Ongoing';
import Completed from './pages/MyLearning/Completed';
import Certifications from './pages/MyLearning/Certifications';
import VerifyCert from './pages/VerifyCert';
import ViewCert from './pages/ViewCert';
import NotFoundPage from './pages/NotFound';
import Profile from './pages/Profile';

// Custom Theme
const THEME = createTheme({
  typography: {
    fontFamily: '"Montserrat", sans-serif',
    fontSize: 12,
    fontWeightLight: 400,
    fontWeightRegular: 500,
    fontWeightMedium: 500,
    fontWeightSemiBold: 600,
    fontWeightBold: 700,
  },
});

function App() {
  return (
    <ThemeProvider theme={THEME}>
      <NotificationProvider>
        <Router>
          <Routes>
            {/* Authentication */}
            <Route path="/signin" element={<SignIn />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            {/* Home */}
            <Route path="/" element={<Home />} />

            {/* Certification */}
            <Route path="/certificate/verify" element={<VerifyCert />} />
            <Route path="/certificate/view/:certId" element={<ViewCert />} />

            <Route path="/profile" element={<Profile />} />

            {/* Course Details */}
            <Route path="/course/:courseSlug" element={<CourseDetails />} />
            <Route path="/course/:courseSlug/lesson/:lessonId" element={<ContentViewer />} />
            <Route path="/course/:courseSlug/completed" element={<CompletedLesson />} />

            {/* Lab Details */}
            <Route path="/lab/:labSlug" element={<LabDetails />} />

            {/* My Learning */}
            <Route path="/my-learning" element={<MyLearning />}>
              <Route index element={<Ongoing />} /> {/* Default to Ongoing */}
              <Route path="completed" element={<Completed />} />
              <Route path="certificates" element={<Certifications />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Router>
      </NotificationProvider>
    </ThemeProvider>
  );
}

export default App;
